import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=423df9e2&scoped=true&"
import script from "./sync.vue?vue&type=script&lang=ts&"
export * from "./sync.vue?vue&type=script&lang=ts&"
import style0 from "./sync.vue?vue&type=style&index=0&id=423df9e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423df9e2",
  null
  
)

export default component.exports